






























import { Component, Mixins } from "vue-property-decorator";
import { LineItem } from "../../../../domain/document/items";
import { Geometry, Point } from "../../../../domain/drawing";
import { SvgPathFactory } from "../../../drawing/utilities";
import {
  DraggableLineDrawableObjectMixin,
  ArrowDrawableMixin
} from "./mixins";
import VectorDragHandles from "../../../dragging/VectorDragHandles.vue";
import { IKeyboardEventHandleable } from "..";
import { KeyCodeProcessor } from "./KeyCodeProcessor";

@Component({
  components: {
    VectorDragHandles,
  }
})
export default class LineObject extends Mixins(
  DraggableLineDrawableObjectMixin,
  ArrowDrawableMixin
) implements IKeyboardEventHandleable {
  editingSource: LineItem;
  absoluteGeometry: Geometry;

  get from(): Point {
    return this.editingSource.vector.from.subtract(
      this.absoluteGeometry.rectangle.topLeft
    );
  }

  get to(): Point {
    return this.editingSource.vector.to.subtract(
      this.absoluteGeometry.rectangle.topLeft
    );
  }

  get path(): string {
    return SvgPathFactory.createPolyline(this.from, this.to);
  }

  get doubleFirstPath(): string {
    return this.createParallelPath(Math.PI / 2, 3);
  }

  get doubleSecondPath(): string {
    return this.createParallelPath(Math.PI / 2 * -1, 3);
  }

  createParallelPath(createAngle: number, gap: number): string {
    if (this.angle === null)  { return this.path; }
    const angle = this.angle + createAngle;
    const difference = new Point(
      gap * Math.cos(angle),
      gap * Math.sin(angle)
    );
    return SvgPathFactory.createPolyline(this.from.add(difference), this.to.add(difference));
  }

  get angle(): number {
    const x = this.from.x - this.to.x;
    const y = this.from.y - this.to.y;
    // 分岐させなくてもMathで対応している？検証未了
    if (x === 0) {
      if (y > 0) { return Math.PI / 2; }
      if (y < 0) { return Math.PI / 2 * -1; }
      return null;
    }
    return Math.atan(y / x);
  }

  handleKeyboardEvent(event: KeyboardEvent): boolean {
    if (!this.editingSource.isEditable) {
      return false;
    }
    const moveOffset = KeyCodeProcessor.toMoveOffset(event.keyCode);
    if (moveOffset) {
      this.writeProperty(s => s.vector = s.vector.move(moveOffset));
      return true;
    }
    return false;
  }
}
